import {
  ACCOUNT_ROUTE,
  ACTIVITY_ROUTE,
  ADDRESS_ROUTE,
  DATE_OF_BIRTH_ROUTE,
  P2P_ACCOUNT_ROUTE,
  P2P_ACTIVITY_ROUTE,
  P2P_IDENTITY_ROUTE,
  P2P_PERSONAL_INFO_ROUTE,
  PASSWORD_ROUTE,
  PHONE_ROUTE,
  PRODUCT_PICKER_ROUTE,
  REVIEW_ADDRESS_ROUTE,
  REVIEW_DOB_ROUTE,
  REVIEW_INTRO_ROUTE,
  REVIEW_NAME_ROUTE,
  REVIEW_SSN_ROUTE,
  SSN_ROUTE,
  TOS_PAGE_ROUTE,
} from 'consts/routeConsts';

/**
 * Routes in a route config should be objects comprised of the following:
 *   name           @type {string} - name of the route
 *                                   the 'name' prop gets passed down and is being used in
 *                                   Step.js -- we should consider renaming this key
 *   successRoute   @type {string} - name of the route that follows in the flow
 *   component      @type {component} - component rendered by the route
 *   default        @type {bool=} - indicates the default route (i.e. index)
 *   locked         @type {bool=} - indicates if route is outside of the flow
 *
 */

export const singleBalanceRoutes = [
  ACCOUNT_ROUTE,
  DATE_OF_BIRTH_ROUTE,
  PHONE_ROUTE,
  PRODUCT_PICKER_ROUTE,
  ADDRESS_ROUTE,
  PASSWORD_ROUTE,
  ACTIVITY_ROUTE,
  SSN_ROUTE,
  TOS_PAGE_ROUTE,
];

export const baseRoutes = [
  ACCOUNT_ROUTE,
  DATE_OF_BIRTH_ROUTE,
  PHONE_ROUTE,
  ADDRESS_ROUTE,
  PASSWORD_ROUTE,
  ACTIVITY_ROUTE,
  SSN_ROUTE,
  TOS_PAGE_ROUTE,
];

export const p2pRoutes = [
  P2P_ACCOUNT_ROUTE,
  P2P_PERSONAL_INFO_ROUTE,
  P2P_IDENTITY_ROUTE,
  P2P_ACTIVITY_ROUTE,
];

//Review groups
export const getUserReviewGroups = groupKey => {
  const groups = {
    group_a: [REVIEW_NAME_ROUTE],
    group_b: [REVIEW_DOB_ROUTE],
    group_c: [REVIEW_ADDRESS_ROUTE],
    group_d: [REVIEW_NAME_ROUTE, REVIEW_DOB_ROUTE],
    group_e: [REVIEW_NAME_ROUTE, REVIEW_ADDRESS_ROUTE],
    group_f: [REVIEW_DOB_ROUTE, REVIEW_ADDRESS_ROUTE],
    group_g: [REVIEW_NAME_ROUTE, REVIEW_DOB_ROUTE, REVIEW_ADDRESS_ROUTE],
  };

  return [REVIEW_INTRO_ROUTE, ...groups[groupKey], REVIEW_SSN_ROUTE];
};
